// extracted by mini-css-extract-plugin
module.exports = {"root":"SettingWrapper_root__2XxEk","column":"SettingWrapper_column__5KAgi","title":"SettingWrapper_title__SEfW0"};